var _rect, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgPaypal2 = function SvgPaypal2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: -0.5,
    width: 31.787,
    height: 18.672,
    rx: 1.5,
    transform: "matrix(1 0 0 -1 .52 18.95)",
    fill: "#fff",
    stroke: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.633 8.934c-.088.579-.53.579-.957.579h-.243l.17-1.08a.134.134 0 01.133-.113h.112c.29 0 .565 0 .707.165.085.1.11.246.078.45zm-.186-1.509h-1.611c-.11 0-.204.08-.221.19l-.652 4.13a.134.134 0 00.133.156h.827a.157.157 0 00.154-.132l.185-1.171a.224.224 0 01.221-.19h.51c1.062 0 1.674-.513 1.834-1.531.072-.445.003-.795-.205-1.04-.23-.27-.636-.412-1.175-.412z",
    fill: "#0079C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.141 8.934c-.088.579-.53.579-.957.579h-.243l.17-1.08a.134.134 0 01.133-.113h.112c.29 0 .565 0 .707.165.085.1.11.246.078.45zm-.186-1.509H7.344c-.11 0-.204.08-.221.19l-.652 4.13a.134.134 0 00.133.156h.77c.11 0 .203-.08.22-.189l.176-1.114a.224.224 0 01.221-.19h.51c1.061 0 1.674-.513 1.834-1.531.072-.445.003-.795-.206-1.04-.229-.27-.635-.412-1.174-.412zM12.696 10.418a.86.86 0 01-.871.736c-.224 0-.403-.072-.518-.208-.114-.135-.157-.328-.121-.542a.863.863 0 01.864-.742c.22 0 .397.072.515.21a.664.664 0 01.13.546zm1.075-1.502h-.772a.134.134 0 00-.132.113l-.034.216-.054-.078c-.167-.243-.54-.324-.912-.324-.852 0-1.58.646-1.722 1.552-.073.452.031.884.288 1.185.235.277.571.393.971.393.688 0 1.069-.442 1.069-.442l-.035.215a.134.134 0 00.133.155h.694c.11 0 .204-.08.222-.189l.417-2.641a.134.134 0 00-.133-.155z",
    fill: "#00457C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.188 10.418a.86.86 0 01-.871.736c-.224 0-.403-.072-.518-.208-.114-.135-.157-.328-.121-.542a.863.863 0 01.865-.742c.219 0 .397.072.514.21a.664.664 0 01.13.546zm1.075-1.502h-.771a.134.134 0 00-.133.113l-.034.216-.054-.078c-.167-.243-.54-.324-.911-.324-.853 0-1.58.646-1.723 1.552-.073.452.031.884.288 1.185.235.277.571.393.971.393.688 0 1.069-.442 1.069-.442l-.035.215a.134.134 0 00.133.155h.695c.11 0 .204-.08.22-.189l.418-2.641a.134.134 0 00-.133-.155z",
    fill: "#0079C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.88 8.916h-.775a.223.223 0 00-.185.098l-1.07 1.575-.454-1.513a.224.224 0 00-.214-.16h-.762a.134.134 0 00-.127.177l.853 2.507-.803 1.133a.134.134 0 00.11.212h.775a.225.225 0 00.184-.096l2.579-3.722a.134.134 0 00-.11-.211z",
    fill: "#00457C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.172 7.539l-.66 4.207a.134.134 0 00.132.155h.665c.11 0 .204-.08.221-.189l.652-4.131a.134.134 0 00-.133-.156h-.744a.134.134 0 00-.133.114z",
    fill: "#0079C1"
  })));
};

export default SvgPaypal2;